import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { IdentityVerificationStatus } from '@40seas/entities/common';
import { z } from 'zod';

export const IdentityVerificationProcessPayloadSchema = z.object({
    identityVerificationStatus: z.string(EnumSchema(IdentityVerificationStatus)).optional(),
    verifyIdentityId: z.string().optional(),
});

export class IdentityVerificationProcessPayload extends FromSchema(IdentityVerificationProcessPayloadSchema) {
    identityVerificationStatus?: IdentityVerificationStatus;
    verifyIdentityId?: string;
}
